import React, { forwardRef } from 'react';

import MUIDialogActions, {
  DialogActionsProps as MUIDialogActionsProps,
} from '@material-ui/core/DialogActions';

interface DialogActionsProps extends MUIDialogActionsProps {}

const DialogActions = forwardRef<HTMLDivElement, DialogActionsProps>(
  (props, ref) => {
    return (
      <MUIDialogActions {...props} ref={ref}>
        {props.children}
      </MUIDialogActions>
    );
  }
);

DialogActions.displayName = 'DialogActions';

export default DialogActions;
